export class ListSqlQueryExecutionsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "sqlEngineId",
            "baseName": "sqlEngineId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "sqlEngineName",
            "baseName": "sqlEngineName",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SqlQueryExecutionStatusFilters",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "DateRangeFilter",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSqlQueryExecutionsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
